import { type H3Event, getCookie, getQuery } from 'h3'

import { getRequestMarket } from '@backmarket/nuxt-module-marketplace/getRequestMarket'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

import { COOKIE_LANGUAGE } from '../constants'

import { getLocaleFromPath } from './getLocaleFromPath'

/**
 * Extracts the locale from a request.
 *
 * Priority:
 * 1. Path (if present and valid)
 *    - Special handling for Nuxt error pages (/__nuxt_error)
 *      Nuxt internally redirects to /__nuxt_error when a route is missing or an error occurs.
 *      The original requested URL is stored in the `url` query param.
 *      We read that to extract the locale, otherwise event.path would only show /__nuxt_error.
 * 2. Cookie (if present)
 * 3. Market default
 */
export function getRequestLocale(event: H3Event) {
  const market = getRequestMarket(event)
  const query = getQuery(event)

  if (
    event.path &&
    event.path.startsWith('/__nuxt_error') &&
    query.error === 'true'
  ) {
    const originalUrl = query.url?.toString()
    const locale = originalUrl && getLocaleFromPath(originalUrl)
    if (locale) return toBcp47Locale(locale)
  }

  const localeFromPath = getLocaleFromPath(event.path)
  if (localeFromPath) return toBcp47Locale(localeFromPath)

  const cookieLocale = getCookie(event, COOKIE_LANGUAGE)
  if (cookieLocale) return toBcp47Locale(cookieLocale)

  return toBcp47Locale(market.defaultLocale)
}
